// src/pages/admin/AdminRedirect.js

import React, { useEffect } from 'react';

const AdminRedirect = () => {
//   useEffect(() => {
//     // Redirect to Nova admin panel
//     window.location.href = `${window.location.protocol}//${window.location.host}/nova`;
//   }, []);

  return (
    <div className="flex align-items-center justify-content-center min-h-screen">
      <div className="text-center">
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }}></i>
        <h2 className="mt-3">Redirecting to Admin Panel...</h2>
      </div>
    </div>
  );
};

export default AdminRedirect;